const companyType = [
    { label: 'SIRE', value: 'SIRE' },
    { label: 'Vetting', value: 'Vetting' },
];

export default companyType;
